import React from 'react';

const LocaleContext = React.createContext({
	localization: 'da_DK',
	decimalSeparator: '.',
	thousandsSeparator: ',',
	thousandsGroup: 3,
});
export default LocaleContext;
